import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c69e71f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid p-5 justify-content-center align-content-start" }
const _hoisted_2 = { class: "col-12 lg:col-5 xl:col-5" }
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = { class: "flex align-items-center justify-content-center m-2" }
const _hoisted_5 = {
  key: 0,
  class: "pi pi-spin pi-spinner",
  style: {"font-size":"4rem"}
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"flex align-items-center justify-content-center m-2\" data-v-c69e71f4><div class=\"grid p-0 m-0\" data-v-c69e71f4><div class=\"col-12 p-0\" data-v-c69e71f4><b data-v-c69e71f4>Profil Kami</b> <br data-v-c69e71f4></div><div class=\"col-12 p-0\" data-v-c69e71f4><span class=\"text-sm\" data-v-c69e71f4>LANTAS EGO DM</span></div></div></div>", 1)
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { key: 0 }

export function render(_ctx, _cache) {
  const _component_p_image = _resolveComponent("p-image")
  const _component_p_pdf = _resolveComponent("p-pdf")
  const _component_p_yt = _resolveComponent("p-yt")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[_ctx.showGif ? 'background-animasi' : 'background-animasi-end'], "overflow-y-auto"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "card color-header-pink",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.$router.push('/home')))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.is_loading)
                ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    width: "60px",
                    src: require(`@/assets/logo.png`),
                    alt: ""
                  }, null, 8, _hoisted_6))
            ]),
            _hoisted_7
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "img-profil"
          }, [
            (item.file != '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_ctx.categorizeFiles(item) == 'image')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: item.file
                      }, [
                        _createVNode(_component_p_image, {
                          src: item.url_cors,
                          alt: "Image",
                          width: "100%",
                          preview: ""
                        }, null, 8, ["src"])
                      ]))
                    : (_ctx.categorizeFiles(item) == 'pdf')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: item.file
                        }, [
                          (item.url_cors)
                            ? (_openBlock(), _createBlock(_component_p_pdf, {
                                key: 0,
                                src: item.url_cors
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_component_p_yt, {
                  key: 1,
                  url: item.url
                }, null, 8, ["url"]))
          ]))
        }), 128))
      ])
    ])
  ], 2))
}